import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, ModalTypeSuccess, StatusCodeActive } from "utils/Constant";
import { ApiCreateProduct, ApiCreateRentalStock, ApiCreateSalesStock, ApiGetBrandList, ApiGetProductById, ApiGetProductList, ApiGetRentalStockById, ApiGetRentalStockPrice, ApiUpdateProduct, ApiUpdateRentalStock } from "utils/constants/api";
import { CheckResponse, GetStatus, money, removeNonNumeric } from "utils/helpers";
import { useModal } from "components/modal/ModalContext";
import Select from 'react-select'
import moment from "moment";
import DatePicker from "components/Input/DatePicker";
import { useCallApi } from "api/apiHooks";
import { PagesFormTitle } from "components/Cards";

export default function RentalStockForm(){
    let navigate = useNavigate()

    const { openModal, closeModal } = useModal()
    const { fetchProductList, fetchCreateRentalStock, fetchUpdateRentalStock, fetchRentalStockById, fetchRentalStockPrice } = useCallApi()

    const { fetch: apiGetProductList } = useFetch(ApiGetProductList)
    const { fetch: apiCreateRentalStock } = useFetch(ApiCreateRentalStock)
    const { fetch: apiUpdateRentalStock } = useFetch(ApiUpdateRentalStock)
    const { fetch: apiGetRentalStockById } = useFetch(ApiGetRentalStockById)
    const { fetch: apiGetRentalStockPrice } = useFetch(ApiGetRentalStockPrice)
    
    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let rentalStockId = queryString.get("rentalStockId")

    const [productOptions, setProductOptions] = useState([])
    const [product, setProduct] = useState({})
    const [stockIn, setStockIn] = useState(new Date())
    const [purchasePrice, setPurchasePrice] = useState('')
    const [rentalPriceHour, setRentalPriceHour] = useState('0')
    const [rentalPriceDay, setRentalPriceDay] = useState('0')
    const [rentalPriceSession, setRentalPriceSession] = useState('0')
    const [sellingPrice, setSellingPrice] = useState('0')
    const [status, setStatus] = useState('')
    const [createBy, setCreateBy] = useState('')
    const [createDate, setCreateDate] = useState('')
    const [updateBy, setUpdateBy] = useState('')
    const [updateDate, setUpdateDate] = useState('')
    
    // Button Event
    const saveBtnClick = () => {
        if(validation()){
            openModal(ModalTypeConfirmation, {
                onConfirm: () => {
                    openModal(ModalTypeLoading)
    
                    if (formType === FormTypeAdd) {
                        fetchCreateRentalStock(
                            product.value, 
                            stockIn, 
                            purchasePrice, 
                            rentalPriceHour, 
                            rentalPriceDay, 
                            rentalPriceSession, 
                            sellingPrice
                        ).then((res) => {
                            if (!CheckResponse(res)) {
                                openModal(ModalTypeFail, { message: res.message })
                                return
                            }

                            openModal(ModalTypeSuccess, {
                                onSuccess: () => {
                                    closeModal()
                                    navigate("/rental-stock") 
                                }
                            })
                        })
                    } else {
                        fetchUpdateRentalStock(
                            rentalStockId,
                            product.value, 
                            stockIn, 
                            purchasePrice, 
                            rentalPriceHour, 
                            rentalPriceDay, 
                            rentalPriceSession, 
                            sellingPrice
                        ).then((res) => {
                            if (!CheckResponse(res)) {
                                openModal(ModalTypeFail, { message: res.message })
                                return
                            }

                            openModal(ModalTypeSuccess, {
                                onSuccess: () => {
                                    closeModal()
                                    navigate("/rental-stock") 
                                }
                            })
                        })
                    }                    
                }
            })
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }
    
    // API Calls
    const getProductList = async() => {
        let res = await apiGetProductList({
            data: {
                productName: '', 
                brandId: '',
                status: '1',
                pageSize: 10000,
                pageIndex: 0
            }
        })

        return res
    }
    const createRentalStock = async() => {
        let res = await apiCreateRentalStock({
            data: {
                productId: product.value,
                stockIn: moment(stockIn).format('YYYY-MM-DDTHH:mm'),
                purchasePrice: purchasePrice.replaceAll(',',''),
                rentalPriceHour: rentalPriceHour.replaceAll(',',''),
                rentalPriceDay: rentalPriceDay.replaceAll(',',''),
                rentalPriceSession: rentalPriceSession.replaceAll(',',''),
                sellingPrice: sellingPrice.replaceAll(',', '')
            }
        })

        return res
    }
    const getRentalStockById = async() => {
        let res = await apiGetRentalStockById({
            data: {
                rentalStockId
            }
        })

        return res
    }
    const updateRentalStock = async() => {
        let res = await apiUpdateRentalStock({
            data: {
                rentalStockId,
                productId: product.value,
                stockIn: moment(stockIn).format('YYYY-MM-DDTHH:mm'),
                purchasePrice: purchasePrice.replaceAll(',',''),
                rentalPriceHour: rentalPriceHour.replaceAll(',',''),
                rentalPriceDay: rentalPriceDay.replaceAll(',',''),
                rentalPriceSession: rentalPriceSession.replaceAll(',',''),
                sellingPrice: sellingPrice.replaceAll(',', '')
            }
        })

        return res
    }
    const getRentalStockPrice = async(productId) => {
        let res = await apiGetRentalStockPrice({
            data: {
                productId
            }
        }).then((response) => {
            if (checkResponse(response)) {
                if (response.data && Object.keys(response.data).length > 0) {
                    let data = response.data

                    setRentalPriceHour(money(data.rentalPriceHour))
                    setRentalPriceSession(money(data.rentalPriceSession))
                    setRentalPriceDay(money(data.rentalPriceDay))
                } else {
                    setRentalPriceHour('0')
                    setRentalPriceSession('0')
                    setRentalPriceDay('0')
                }
            }
        })

        return res
    }

    // Function
    const validation = () => {
        if (product === null){
            openModal(ModalTypeFail, { message: 'Product is required!' })
            return false
        } else if (product.value === '') {
            openModal(ModalTypeFail, { message: 'Product is required!' })
            return false
        }
        if (stockIn === null) {
            openModal(ModalTypeFail, { message: 'Stock In Date is required!' })
            return false
        }
        if (purchasePrice === '') {
            openModal(ModalTypeFail, { message: 'Purchase Price is required!' })
            return false
        }
        if (rentalPriceHour === '') {
            openModal(ModalTypeFail, { message: 'Rental Price / Hour is required!' })
            return false
        }
        if (rentalPriceDay === '') {
            openModal(ModalTypeFail, { message: 'Rental Price / Day is required!' })
            return false
        }
        if (rentalPriceSession === '') {
            openModal(ModalTypeFail, { message: 'Rental Price / Session is required!' })
            return false
        }
        if (sellingPrice === '') {
            openModal(ModalTypeFail, { message: 'Selling Price is required!' })
            return false
        }

        return true
    }
    const checkResponse = (res) => {
        if (res.status === ApiResponseSuccess) {
            return true
        } else if (res.status === ApiResponseStatusUnauthorized) {
            window.location.href = "/login"
            return false
        } else {
            openModal(ModalTypeFail, { message: res.message })
            return false
        }
    }
    
    useEffect(() => {
        openModal(ModalTypeLoading)
        
        getProductList().then((res) => {
            if (checkResponse(res)) {
                let data = res?.data?.listData
                let tempData = [{ label: 'Select Product', value: '' }]

                data.map((data, i) => tempData.push({ label: data.brandName + ' ' + data.productName.toUpperCase(), value: String(data.productId), price: String(data.price) }))

                setProductOptions(tempData)

                // If Form Type Edit then get data
                if (formType === FormTypeEdit) {
                    getRentalStockById().then((res) => {
                        if (checkResponse(res)) {
                            let data = res.data

                            // Data
                            setProduct({ label: data.brandName + ' ' + data.productName.toUpperCase(), value: String(data.productId) })
                            setStockIn(data.stockIn)
                            setPurchasePrice(money(data.purchasePrice))
                            setRentalPriceHour(money(data.rentalPriceHour))
                            setRentalPriceDay(money(data.rentalPriceDay))
                            setRentalPriceSession(money(data.rentalPriceSession))
                            setSellingPrice(money(data.sellingPrice))

                            // Header
                            setStatus(data.status)
                            setCreateBy(data.createBy)
                            setCreateDate(data.createDate)
                            setUpdateBy(data.updateBy)
                            setUpdateDate(data.updateDate)

                            closeModal()
                        }
                    })
                } else {
                    closeModal()
                }
            }
        })
    }, [])

    return(
        <div className="flex p-3 min-h-full w-full">
            <div className="flex flex-col w-full justify-between gap-2 sm:bg-white sm:p-6 sm:rounded-xl sm:shadow-lg min-h-full">
                <div>
                    <PagesFormTitle
                        title={'Rental Stock Detail'}
                        formType={formType}
                        status={status}
                        createDate={createDate}
                        updateDate={updateDate}
                        updateBy={updateBy}
                    />

                    <div className="mt-5 flex flex-col gap-3 ">
                        {/* Product */}
                        <CardForm title='Product'>
                            <Select options={productOptions} value={product} onChange={(e) => { setProduct(e); setSellingPrice(money(e.price)); getRentalStockPrice(e.value) }} placeholder='Select Product' />
                        </CardForm>

                        {/* Stock In Date */}
                        <CardForm title='Stock In Date'>
                            <DatePicker value={stockIn} onChange={(e) => { setStockIn(e) }} className='h-11 w-full bg-white' />
                        </CardForm>
                        
                        {/* Purchase Price */}
                        <CardForm title='Purchase Price'>
                            <input className="input" value={purchasePrice} onChange={(e) => { setPurchasePrice(money(e.target.value)) }} maxLength={12} />
                        </CardForm>

                        {/* Rental Price Hour */}
                        <CardForm title='Rental Price / Hour'>
                            <input className="input" value={rentalPriceHour} onChange={(e) => { setRentalPriceHour(money(e.target.value)) }} maxLength={12} />
                        </CardForm>

                        {/* Rental Price Session */}
                        <CardForm title='Rental Price / Session'>
                            <input className="input" value={rentalPriceSession} onChange={(e) => { setRentalPriceSession(money(e.target.value)) }} maxLength={12} />
                        </CardForm>

                        {/* Rental Price Day */}
                        <CardForm title='Rental Price / Day'>
                            <input className="input" value={rentalPriceDay} onChange={(e) => { setRentalPriceDay(money(e.target.value)) }} maxLength={12} />
                        </CardForm>

                        {/* Selling Price */}
                        <CardForm title='Selling Price'>
                            <input className="input" value={sellingPrice} onChange={(e) => { setSellingPrice(money(e.target.value)) }} maxLength={12} />
                        </CardForm>
                    </div>
                </div>            

                {/* Button */}
                <div className="mt-5 flex flex-wrap justify-end gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                    <BackButton onClick={backBtnClick} />
                </div>
            </div>
        </div>
        
    )
}

const CardForm = ({ title, children }) => {
    return (
        <div className="flex flex-col sm:flex-row sm:items-center">
            <div className="w-48">
                <span>{title}</span>
            </div>
            <div className="px-4 hidden sm:block">
                <span>:</span>
            </div>
            <div className="w-full sm:w-72">
                {children}
            </div>
        </div>
    )
}